import {useStore} from "vuex";
import {computed} from "vue";
import {PATH_HANDLER} from "@/config";

export default function(step){
  const store = useStore()
  const results = computed(() => {
    return store.state.moduleA.results;
  })

  function ruleTracer(ruleStep, values){
    let data = []
    data = results.value.filter(item => {
      return item.step === ruleStep && values.includes(item.val)
    })
    return data.length > 0
  }

  const applyRule = (value) => {
    if (step === "step2"){
      if(ruleTracer(6, ["_milbothsides"]) && ["volumeRound", "softFlat"].includes(value)){
        return {
          visible:false,
          rule:"Step6 ミルグレイン「両サイド」以外を選ぶと選択できます。",
        }
      }
      else if(ruleTracer(7, ["hineridome", "hineriboriBase"]) && ["flat", "plate"].includes(value)){
          return {
            visible:false,
            rule:"Step7 外側ダイヤ「ひねり留め」「ひねり彫り」以外を選ぶと選択できます。",
          }
      }
      else {
        return {visible: true}
      }
    }
    else if (step === "step3"){
      if (ruleTracer(4, ["brush"]) && ["hammer","antique","glitter","stone","earth","linen"].includes(value)){
        return {
          visible:false,
          rule:"Step4 表面の仕上げ「ブラシ」以外を選ぶと選択できます。",
          image: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_"+value+"_2.6.jpg"
        }
      } else {
        return {visible:true}
      }
    }
    else if (step === "step4"){
      if (!ruleTracer(3, ["simple"]) && ["brush"].includes(value)){
        return {
          visible:false,
          rule:"Step3 テクスチャー「シンプル」を選ぶと選択できます。",
          image: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_"+value+"_2.6.jpg"
        }
      } else {
        return {visible:true}
      }
    }
    else if (step === "step5"){
      if (ruleTracer(7, ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase",
      "fusekomirandom3Base", "fusekomirandom5Base", "fusekomirandom8Base",
      "tumedomerandom3Base", "tumedomerandom5Base", "tumedomerandom8Base","rosecutyontendomeBase", "rosecuthachitendomeBase"]) && ["1.8mm", "2.0mm"].includes(value)){
        return {
          visible:false,
          //rule:"Step7 外側ダイヤ「太陽留め」「星留め」「太陽彫り」「星彫り」「ふせこみランダム」「爪留めランダム」「ローズカット（4・8点留め）」 以外を選ぶと選択できます。",
          rule:"Step7 外側ダイヤ「ふせこみ」「4点留め（平行・十字）」「ひねり留め」「ひねり彫り」のいずれかをお選びください。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if (ruleTracer(7, ["rosecutyontendomeBase", "rosecuthachitendomeBase"]) && ["2.2mm"].includes(value)){
        return {
          visible:false,
          rule:"Step7 外側ダイヤ「ローズカット」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if (ruleTracer(7, ["hineridome"]) && ["1.8mm"].includes(value)){
        return {
          visible:false,
          //rule: "Step7 外側ダイヤ「ひねり留め」以外を選ぶと選択できます。",
          rule: "Step7 外側ダイヤ「ふせこみ」「4点留め（平行・十字）」「ひねり彫り」のいずれかをお選びください。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg",
        }
      }
      else if (ruleTracer(7, ["hineridome", "hineriboriBase"]) && ["2.8mm", "3.0mm", "3.2mm", "3.4mm", "3.6mm", "3.8mm"].includes(value)){
        return {
          visible:false,
          rule: "Step7 外側ダイヤ「ひねり留め」「ひねり彫り」以外を選ぶと選択できます。",
          image: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg",
        }
      }
      else if ((ruleTracer(7, ["fusekomiBase", "yontendomeheikouBase", "yontendomejujiBase"]) && ["1.8mm"].includes(value)) && (ruleTracer(6, ["_milbothsides"]) && ["fusekomiBase", "yontendomeheikouBase", "yontendomejujiBase"].includes(value))){
        return {
          visible:false,
          rule:"Step7 外側ダイヤ「ふせこみ」「4点留め」とStep6 ミルグレイン「両サイド」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if ((ruleTracer(7, ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase"]) && ["2.2mm"].includes(value)) && (ruleTracer(6, ["_milbothsides"]) && ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase"].includes(value))){
        return {
          visible:false,
          rule:"Step7 外側ダイヤ「太陽留め」「星留め」「太陽彫り」「星彫り」とStep6 ミルグレイン「両サイド」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if ((ruleTracer(7, ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase", "rosecutyontendomeBase", "rosecuthachitendomeBase"]) && ["2.4mm"].includes(value)) && (ruleTracer(6, ["_milbothsides"]) && ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase", "rosecutyontendomeBase", "rosecuthachitendomeBase"].includes(value))){
        return {
          visible:false,
          rule:"Step7 外側ダイヤ「太陽留め」「星留め」「太陽彫り」「星彫り」「ローズカット」とStep6 ミルグレイン「両サイド」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if ((ruleTracer(7, ["rosecutyontendomeBase", "rosecuthachitendomeBase"]) && ["2.6mm"].includes(value)) && (ruleTracer(6, ["_milbothsides"]) && ["rosecutyontendomeBase", "rosecuthachitendomeBase"].includes(value))){
        return {
          visible:false,
          rule:"Step7 外側ダイヤ「ローズカット」とStep6 ミルグレイン「両サイド」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else {
        return {visible:true}
      }
    }
    else if (step === "step6"){
      if (ruleTracer(2, ["volumeRound", "softFlat"]) && ["_milbothsides"].includes(value)){
        return {
          visible:false,
          rule:"※step2 リングの形にて「ラウンド」「フラット」「プレート」のいずれかをお選びください。",
          image: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6"+value+".jpg"
        }
      }
      else if (ruleTracer(7, ["hineridome", "hineriboriBase", "fusekomirandom3Base", "fusekomirandom5Base", "fusekomirandom8Base",
      "tumedomerandom3Base", "tumedomerandom5Base", "tumedomerandom8Base"]) && ["_milbothsides", "_milcenter"].includes(value)){
        return {
          visible:false,
          rule:"Step7 外側ダイヤ「複数のダイヤを留める」以外を選ぶと選択できます。",
          image: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if ((ruleTracer(5, ["1.8mm"]) && ["fusekomiBase", "yontendomeheikouBase", "yontendomejujiBase"].includes(value)) && (ruleTracer(7, ["fusekomiBase", "yontendomeheikouBase", "yontendomejujiBase"]) && ["_milbothsides"].includes(value))){
        return {
          visible:false,
          rule:"Step5 リング幅「1.8mm」とStep7 外側ダイヤ「ふせこみ」「4点留め」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if ((ruleTracer(5, ["2.2mm"]) && ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase"].includes(value)) && (ruleTracer(7, ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase"]) && ["_milbothsides"].includes(value))){
        return {
          visible:false,
          rule:"Step5 リング幅「2.2mm」とStep7 外側ダイヤ「太陽留め」「星留め」「太陽彫り」「星彫り」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if ((ruleTracer(5, ["2.4mm"]) && ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase", "rosecutyontendomeBase", "rosecuthachitendomeBase"].includes(value)) && (ruleTracer(7, ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase", "rosecutyontendomeBase", "rosecuthachitendomeBase"]) && ["_milbothsides"].includes(value))){
        return {
          visible:false,
          rule:"Step5 リング幅「2.2mm」とStep7 外側ダイヤ「太陽留め」「星留め」「太陽彫り」「星彫り」「ローズカット」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if ((ruleTracer(5, ["2.6mm"]) && ["rosecutyontendomeBase", "rosecuthachitendomeBase"].includes(value)) && (ruleTracer(7, ["rosecutyontendomeBase", "rosecuthachitendomeBase"]) && ["_milbothsides"].includes(value))){
        return {
          visible:false,
          rule:"Step5 リング幅「2.6mm」とStep7 外側ダイヤ「ローズカット」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else {
        return {visible:true}
      }
    }
    else if (step === "step7"){
      if (ruleTracer(2, ["flat", "plate"]) && ["hineridome", "hineriboriBase"].includes(value)){
        return {
          visible:false,
          rule:"step2 リングのかたち「フラット」「プレート」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if (ruleTracer(6, ["_milbothsides", "_milcenter"]) && ["hineridome", "hineriboriBase", "fusekomirandom3Base", "fusekomirandom5Base", "fusekomirandom8Base",
      "tumedomerandom3Base", "tumedomerandom5Base", "tumedomerandom8Base"].includes(value)){
        return {
          visible:false,
          rule:"Step6 ミルグレイン を外すと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if (ruleTracer(5, ["1.8mm", "2.0mm",]) && ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase"].includes(value)){
        return {
          visible:false,
          rule:"※リング幅2.2mm以上　ミルグレイン両サイドを入れる場合は2.8mm幅以上をお選びください。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if (ruleTracer(5, ["1.8mm", "2.0mm", "2.2mm"]) && ["rosecutyontendomeBase", "rosecuthachitendomeBase"].includes(value)){
        return {
          visible:false,
          rule:"※リング幅2.4mm以上　ミルグレイン両サイドを入れる場合は2.8mm幅以上をお選びください。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if (ruleTracer(5, ["1.8mm", "2.0mm"]) && ["fusekomirandom3Base", "fusekomirandom5Base", "fusekomirandom8Base",
        "tumedomerandom3Base", "tumedomerandom5Base", "tumedomerandom8Base"].includes(value)){
        return {
          visible:false,
          rule:"※2.2mm幅以上をご選択の場合に可能です。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if (ruleTracer(5, ["1.8mm", "2.8mm", "3.0mm", "3.2mm", "3.4mm", "3.6mm", "3.8mm"]) && ["hineridome"].includes(value)){
        return {
          visible:false,
          rule: "※2.0mm/2.2mm/2.4mm/2.6mm幅をご選択の場合に可能です。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg",
        }
      }
      else if (ruleTracer(5, ["2.8mm", "3.0mm", "3.2mm", "3.4mm", "3.6mm", "3.8mm"]) && ["hineriboriBase"].includes(value)){
        return {
          visible:false,
          rule: "※1.8mm/2.0mm/2.2mm/2.4mm/2.6mm幅をご選択の場合に可能です。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg",
        }
      }

      // ここからダブルルール
      else if ((ruleTracer(5, ["1.8mm"]) && ["fusekomiBase", "yontendomeheikouBase", "yontendomejujiBase"].includes(value)) && (ruleTracer(6, ["_milbothsides"]) && ["fusekomiBase", "yontendomeheikouBase", "yontendomejujiBase"].includes(value))){
        return {
          visible:false,
          rule:"Step5 リング幅「1.8mm」とStep6 ミルグレイン「両サイド」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if ((ruleTracer(5, ["2.2mm"]) && ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase"].includes(value)) && (ruleTracer(6, ["_milbothsides"]) && ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase"].includes(value))){
        return {
          visible:false,
          rule:"※リング幅2.2mm以上　ミルグレイン両サイドを入れる場合は2.8mm幅以上をお選びください。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if ((ruleTracer(5, ["2.4mm"]) && ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase", "rosecutyontendomeBase", "rosecuthachitendomeBase"].includes(value)) && (ruleTracer(6, ["_milbothsides"]) && ["taiyodomeBase", "hoshidomeBase", "taiyoboriBase", "hoshiboriBase", "rosecutyontendomeBase", "rosecuthachitendomeBase"].includes(value))){
        return {
          visible:false,
          rule:"※リング幅2.4mm以上　ミルグレイン両サイドを入れる場合は2.8mm幅以上をお選びください。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else if ((ruleTracer(5, ["2.6mm"]) && ["rosecutyontendomeBase", "rosecuthachitendomeBase"].includes(value)) && (ruleTracer(6, ["_milbothsides"]) && ["rosecutyontendomeBase", "rosecuthachitendomeBase"].includes(value))){
        return {
          visible:false,
          rule:"Step5 リング幅「2.6mm」とStep6 ミルグレイン「両サイド」以外を選ぶと選択できます。",
          ring: PATH_HANDLER.path+"/images/common/ring/round/2.6/simple_matte_2.6.jpg"
        }
      }
      else {
        return {visible:true}
      }
    } else {
      return {visible: true}
    }
  }

  return {applyRule}
}
